var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgInterestManualActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 84,
    viewBox: "0 0 787 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -18,
    y: -18,
    width: 823,
    height: 120
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9px)",
      clipPath: "url(#bgblur_0_2028_3508_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H767C777.77 0.500007 786.5 9.23045 786.5 20V64C786.5 74.7696 777.77 83.5 767 83.5H20C9.23045 83.5 0.5 74.7695 0.5 64V20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "url(#paint0_linear_2028_3508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H767C777.77 0.500007 786.5 9.23045 786.5 20V64C786.5 74.7696 777.77 83.5 767 83.5H20C9.23045 83.5 0.5 74.7695 0.5 64V20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "url(#paint1_linear_2028_3508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2028_3508_clip_path",
    transform: "translate(18 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H767C777.77 0.500007 786.5 9.23045 786.5 20V64C786.5 74.7696 777.77 83.5 767 83.5H20C9.23045 83.5 0.5 74.7695 0.5 64V20C0.5 9.23045 9.23045 0.5 20 0.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2028_3508",
    x1: 393.5,
    y1: 84,
    x2: 393.5,
    y2: -4.26805e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8BA9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8BA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2028_3508",
    x1: 393.5,
    y1: 0,
    x2: 393.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4AFFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4AFFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestManualActive);
export default __webpack_public_path__ + "static/media/interest-manual-active.814dae04687caf1ac1f0f5e119fe7061.svg";
export { ForwardRef as ReactComponent };